// src/components/Footer.js
import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import logo from '../images/logo.jpg';
import { ClockIcon, FacebookIcon, InstagramIcon } from './Icons';
import './Footer.css';

export default function Footer() {
  const { t } = useTranslation();

  // Tous les liens de la barre de navigation, exportés ici sous "Liens rapides"
  const liensRapides = [
    { label: t('menu.home'), path: '/' },
    { label: t('menu.news'), path: '/actualites' },
    { label: t('menu.projects'), path: '/projets' },
    { label: t('menu.about'), path: '/apropos' },
    { label: t('menu.contact'), path: '/contact' },
  ];

  // Deux sous-colonnes pour "Liens rapides", comme sur le site Gramen
  const milieu = Math.ceil(liensRapides.length / 2);
  const colonne1 = liensRapides.slice(0, milieu);
  const colonne2 = liensRapides.slice(milieu);

  const nouvelles = [
    {
      titre: t('menu.footerNews1Title'),
      date: t('menu.footerNews1Date'),
    },
    {
      titre: t('menu.footerNews2Title'),
      date: t('menu.footerNews2Date'),
    },
  ];

  return (
    <footer className="site-footer">
      <div className="site-footer-grid">
        {/* Colonne 1 : logo + tagline */}
        <div className="footer-col footer-brand">
          <img src={logo} alt="Logo DIBADAN" className="footer-logo" />
          <p>{t('menu.footer')}</p>
        </div>

        {/* Colonne 2 : Nouvelles */}
        <div className="footer-col">
          <h3>{t('menu.footerNewsHeading')}</h3>
          <hr className="footer-divider" />
          <ul className="footer-news-list">
            {nouvelles.map((item) => (
              <li key={item.titre}>
                <p className="footer-news-title">{item.titre}</p>
                <span className="footer-news-date">
                  <ClockIcon />
                  {item.date}
                </span>
              </li>
            ))}
          </ul>
        </div>

        {/* Colonne 3 : Liens rapides, sur 2 sous-colonnes */}
        <div className="footer-col">
          <h3>{t('menu.footerLinksHeading')}</h3>
          <hr className="footer-divider" />
          <div className="footer-links-columns">
            <ul>
              {colonne1.map((lien) => (
                <li key={lien.path}>
                  <Link to={lien.path}>{lien.label}</Link>
                </li>
              ))}
            </ul>
            <ul>
              {colonne2.map((lien) => (
                <li key={lien.path}>
                  <Link to={lien.path}>{lien.label}</Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Barre du bas : crédit + réseaux sociaux */}
      <div className="footer-bottom">
        <p>{t('menu.footer1')}</p>
        <div className="footer-socials">
          <a
            href="https://www.facebook.com/groups/28300444646228501"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook"
          >
            <FacebookIcon />
          </a>
          <a
            href="https://www.instagram.com/diasporabakong/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
          >
            <InstagramIcon />
          </a>
        </div>
      </div>
    </footer>
  );
}
